module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [(!this.$props.pastRun) ? _c('race-table-list', {
    attrs: {
      "subtitle": "finished",
      "races": _vm.racesFinished,
      "message-empty-list": "There's no finished races",
      "type": "resume"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "live-run__content pastRunContent"
  }, [(this.$props.pastRun) ? _c('race-header', {
    attrs: {
      "isPastRun": this.$props.pastRun
    }
  }) : _vm._e(), _vm._v(" "), (this.$props.pastRun) ? _c('runners-table', {
    attrs: {
      "isPastRun": this.$props.pastRun
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71d41ae2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/PastRun.vue
// module id = 1837
// module chunks = 1